var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-record"},[_c('div',{staticClass:"fb fb-main-center fb-col"},[_vm._m(0),_c('div',{staticClass:"font-26"},[_vm._v(" "+_vm._s(_vm.content || '当天暂无记录')+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fb fb-main-center"},[_c('i',{staticClass:"iconfont font-120 c-D1D1D1"},[_vm._v("")])])
}]

export { render, staticRenderFns }